import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { getOrder } from './redux/actions'
import { ApplicationState } from 'AppReducer'
import { getOrderStatusList } from 'panel/order-status/redux/actions'

import Persons from './components/Persons'
import Payment from './components/Payment'
import OrderProducts from './components/OrderProducts'
import Orderhistory from './components/Orderhistory'
import OrderAddress from './components/OrderAddress'
import OrderReview from './components/OrderReview'

export const paymentMethods = {
  DEBIT: 'Cartão de Débito',
  CREDIT: 'Cartão de Crédito',
  DEFAULT: 'Dinheiro'
}

export const paymentTypes = {
  MONEY: 'Dinheiro',
  IN_APP: 'In-App',
  CARD_MACHINE: 'Máquininha de Cartão'
}

const Order: React.FC = () => {
  const dispatch = useDispatch()

  const [isFetching, setFetching] = useState(false)

  const { partnerId, orderId } = useParams<{ [x: string]: string }>()
  const { order } = useSelector((state: ApplicationState) => state.orderReducer)

  useEffect(() => {
    if (partnerId && orderId) {
      ;(async () => {
        setFetching(true)
        await getOrder(partnerId, orderId)(dispatch)
        setFetching(false)
      })()
    }
  }, [partnerId, orderId, dispatch])

  useEffect(() => {
    getOrderStatusList()(dispatch)
  }, [dispatch])

  if (isFetching) {
    return (
      <div className="row">
        <h2><i className="fa fa-spin fa-spinner"/> Buscando Ordem de Compra</h2>
      </div>
    )
  }

  if (!order) {
    return (
      <div className="row">
        <h2>Ordem não encontrada</h2>
      </div>
    )
  }

  return (
    <div className="row">
      <Persons order={order} />
      <Payment order={order} />

      <div className="row margin-top-32">
        <h2><i className="fa fa-biking"/> Endereço & Avaliação</h2>

        <div className="row margin-top-16">
          <div className="row col-6 padding-right-8">
            <div className="row panel center-center" style={{ height: 155 }}>
              <OrderAddress order={order} />
            </div>
          </div>
          <div className="row col-6 padding-left-8">
            <div className="row panel center-center" style={{ height: 155 }}>
              <OrderReview order={order} />
            </div>
          </div>
        </div>
      </div>

      <div className="row margin-top-32 align-start">
        <h2 className="margin-bottom-16"><i className="fa fa-history"/> Produtos & Histórico</h2>

        <div className="row col-6 padding-right-8">
          <OrderProducts order={order} />
        </div>

        <div className="row col-6 padding-left-8">
          <div className="row panel center-center">
            <Orderhistory order={order} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Order
